import { TFunction } from "i18next";
import { enqueueSnackbar } from "notistack";

export const handleError = (
  error: any,
  t?: TFunction<"translation", undefined>,
) => {
  try {
    // Log full error object for debugging Zod validation errors
    console.error("[handleError] Full error object:", error);
    console.error("[handleError] Error response:", error?.response);
    console.error("[handleError] Error response data:", error?.response?.data);
    
    // Log Zod errors if present
    if (error?.response?.data?.errors) {
      console.error("[handleError] Validation errors (Zod):", error.response.data.errors);
    }
    if (error?.response?.data?.zodError) {
      console.error("[handleError] Zod error details:", error.response.data.zodError);
    }
    
    const messages = error?.response?.data?.message || error?.message;
    const isArray = Array.isArray(messages);
    if (isArray) {
      for (let message of messages) {
        enqueueSnackbar &&
          enqueueSnackbar(t ? t(`error.${message}`) : message, {
            variant: "error",
          });
      }
    } else {
      enqueueSnackbar &&
        enqueueSnackbar(t ? t(`error.${messages}`) : messages, {
          variant: "error",
        });
    }
  } catch (e) {
    console.error("[handleError] Error in handleError:", e);
  }
};
